import { Tooltip } from "antd";
import { ColumnType } from "antd/es/table";

import {
  getEnumKeys,
  REVERSE_ORDER_MAP,
  UserCheckGridDto,
  RISK_LEVELS,
  WalletRiskLevel,
  RISK_LEVELS_FILTERS,
} from "interfaces";
import { Status, TxButton } from "ui";
import {
  dateFormat,
  detectWalletNetwork,
  EXPLORER_LINK_TYPE,
  getBlockchainExplorerLink,
  getFilterIcon,
  getSortIcon,
} from "utils";
import { UserStore } from "stores/UserStore";
import { AmlCheckList } from "stores/AmlCheckList";

import styles from "./amlChecks.module.css";
import { DetailReportButton } from "./DetailReport";
import { EmptyString } from "constants/strings";

export const getColumns = (user: UserStore, amlChecks: AmlCheckList): Array<ColumnType<UserCheckGridDto>> => {
  const { isJuniorOperator, isSeniorOperator, isRiskManager } = user.roles;

  const isOperator = isJuniorOperator || isSeniorOperator || isRiskManager;

  return [
    {
      dataIndex: "address",
      key: "address",
      title: "Адрес кошелька",
      width: 215,
      render: (_: any, record: UserCheckGridDto) => {
        const network = detectWalletNetwork(record.address);
        return network ? (
          <TxButton
            text={record.address}
            href={getBlockchainExplorerLink(network, record.address, EXPLORER_LINK_TYPE.address)}
            showCopyBtn
            isWalletAddress
          />
        ) : (
          "Некорректный адрес"
        );
      },
    },
    {
      dataIndex: "created",
      key: "created",
      title: "Дата проверки",
      width: 160,
      sorter: { multiple: 3 },
      sortOrder: amlChecks?.sorters?.statusDate && REVERSE_ORDER_MAP[amlChecks.sorters.statusDate],
      sortIcon: getSortIcon,
      render: (date: string) => {
        return dateFormat(date);
      },
    },
    {
      dataIndex: "riskLevel",
      key: "riskLevels",
      title: "Уровень риска",
      filterMultiple: true,
      defaultFilteredValue: amlChecks.queryParams["riskLevels"],
      filtered: "riskLevels" in amlChecks.queryParams,
      filters: getEnumKeys(RISK_LEVELS_FILTERS).map((key) => ({
        text: RISK_LEVELS.texts[key],
        value: key,
      })),
      width: 160,
      align: "left",
      filterIcon: (filtered: boolean) => getFilterIcon(filtered),
      render: (riskLevel: WalletRiskLevel) => {
        return riskLevel ? (
          <Status color={RISK_LEVELS.colors[riskLevel]} children={RISK_LEVELS.texts[riskLevel]} alignRight={false} />
        ) : (
          <Status color={"gray"} children={"В обработке"} />
        );
      },
    },
    isOperator && {
      dataIndex: "companyName",
      key: "companyName",
      title: "Инициатор проверки",
      width: 300,
      className: `text-clamp-ellipsis ${styles.companyName}`,
      render: (_: any, record: UserCheckGridDto) => {
        return (
          <Tooltip trigger="hover" placement="topLeft" title={record.companyName}>
            <span>{record.companyName}</span>
          </Tooltip>
        );
      },
    },
    !isOperator && {
      dataIndex: "userFullName",
      key: "userFullName",
      title: "Инициатор проверки",
      width: 390,
      className: `text-clamp-ellipsis ${styles.userFullName}`,
      render: (_: any, record: UserCheckGridDto) => {
        return (
          <Tooltip trigger="hover" placement="topLeft" title={record.userFullName}>
            <span>{record.userFullName}</span>
          </Tooltip>
        );
      },
    },
    isOperator && {
      dataIndex: "checkId",
      key: "checkId",
      title: "Детальный результат",
      width: 160,
      render: (_: any, record: UserCheckGridDto) => {
        return record.checkId ? <DetailReportButton checkId={record.checkId} type="wallet" /> : EmptyString;
      },
    },
  ].filter((c) => !!c) as Array<ColumnType<UserCheckGridDto>>;
};
